export default __webpack_public_path__ + "static/media/harstad_hd.3a5bde32.webp";